const svgElement = document.createElementNS(
  'http://www.w3.org/2000/svg',
  'svg'
);

// const markup = `<svg ><use xlink:href="#icon-logotype"></use></svg>`;
